import React, { ReactElement, PropsWithChildren } from 'react';

export type CardHeaderProps = PropsWithChildren<{
  className?: string;
}>;

export function CardHeader({
  className,
  children,
}: CardHeaderProps): ReactElement {
  return (
    <div className={className} aria-label="Card header">
      {children}
    </div>
  );
}
